import { render, staticRenderFns } from "./ConfirmationTypeAdditionals.vue?vue&type=template&id=e7b83afa&scoped=true"
import script from "./ConfirmationTypeAdditionals.vue?vue&type=script&lang=ts&setup=true"
export * from "./ConfirmationTypeAdditionals.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ConfirmationTypeAdditionals.vue?vue&type=style&index=0&id=e7b83afa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7b83afa",
  null
  
)

export default component.exports